import React from 'react';
import { Bar, Pie } from 'react-chartjs-2';
import { Paper, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js';

// Registrar componentes de Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

const useStyles = makeStyles((theme) => ({
  chartContainer: {
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));

// Colores predefinidos para los gráficos
const CHART_COLORS = [
  '#FF6384',
  '#36A2EB',
  '#FFCE56',
  '#4BC0C0',
  '#9966FF',
  '#FF9F40',
  '#FF6384',
  '#C9CBCF',
  '#4BC0C0',
  '#FF6384',
  '#36A2EB',
  '#FFCE56'
];

const ChartVisualization = ({ data, type = 'bar', height = 400 }) => {
  const classes = useStyles();

  if (!data || data.length === 0) {
    return null;
  }

  // Preparar datos para el gráfico
  const labels = data.map(item => `${item.flag} ${item.countryName}`);
  const values = data.map(item => item.count);
  const backgroundColors = data.map((_, index) => CHART_COLORS[index % CHART_COLORS.length]);

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Clientes por País',
        data: values,
        backgroundColor: backgroundColors,
        borderColor: backgroundColors.map(color => color.replace('0.6', '1')),
        borderWidth: 1
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: type === 'pie',
        position: 'right'
      },
      title: {
        display: true,
        text: 'Distribución Geográfica de Clientes'
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const label = context.label || '';
            const value = context.parsed.y || context.parsed;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = ((value / total) * 100).toFixed(2);
            return `${label}: ${value} (${percentage}%)`;
          }
        }
      }
    },
    scales: type === 'bar' ? {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0
        }
      }
    } : undefined
  };

  return (
    <Paper className={classes.chartContainer}>
      <Box style={{ height: `${height}px` }}>
        {type === 'bar' ? (
          <Bar data={chartData} options={options} />
        ) : (
          <Pie data={chartData} options={options} />
        )}
      </Box>
    </Paper>
  );
};

export default ChartVisualization;
